import {
  Alert,
  Box,
  CardContent,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { Close as CloseIcon } from '@mui/icons-material';
import React, { useContext, useState } from 'react';
import { I_Folder } from '../../../interfaces/InstallationTypes';
import { UserContext } from '../../../contexts/userContext';
import FolderForm from './folderForm';
import { InstallationsContext } from '../../../contexts/InstallationsContextProvider';
import { UserType } from '../../../interfaces/UserTypes';
import InstallationForm from '../Installations/installationForm';
import SalidomoInstallationForm from '../SalidomoInstallations/SalidomoInstallationForm';
import SodiostorehomeInstallationForm from '../SodiohomeInstallations/SodistorehomeInstallationForm';

interface TreeInformationProps {
  folder: I_Folder;
}

function TreeInformation(props: TreeInformationProps) {
  if (props.folder === null) {
    return null;
  }
  const theme = useTheme();
  const context = useContext(UserContext);
  const { currentUser } = context;
  const [formValues, setFormValues] = useState(props.folder);
  const [openModalFolder, setOpenModalFolder] = useState(false);
  const [openModalInstallationChoice, setOpenModalInstallationChoice] =
    useState(false);
  const [openModalInstallation, setOpenModalInstallation] = useState(false);
  const requiredFields = ['name'];
  const [openModalDeleteFolder, setOpenModalDeleteFolder] = useState(false);
  const installationContext = useContext(InstallationsContext);
  const {
    loading,
    setLoading,
    error,
    setError,
    updated,
    setUpdated,
    updateFolder,
    deleteFolder,
    fetchAllInstallations
  } = installationContext;

  const [product, setProduct] = useState('Salimax');

  const handleChangeInstallationChoice = (e) => {
    setProduct(e.target.value); // Directly update the product state
  };

  const ProductTypes = ['Salimax', 'Salidomo', 'SodistoreHome', 'SodistoreMax'];

  const isMobile = window.innerWidth <= 1490;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleFolderInformationUpdate = () => {
    setLoading(true);
    setError(false);
    updateFolder(formValues, product);
  };

  const handleNewInstallationInsertion = () => {
    setOpenModalInstallationChoice(true);
  };

  const handleCancelSubmitInstallationChoice = () => {
    setOpenModalInstallationChoice(false);
  };

  const handleSubmitInstallationChoice = () => {
    setOpenModalInstallationChoice(false);
    setOpenModalInstallation(true);
  };

  const handleNewFolderInsertion = () => {
    setOpenModalFolder(true);
  };

  const handleDeleteFolder = () => {
    setLoading(true);
    setError(false);
    setOpenModalDeleteFolder(true);
  };

  const deleteFolderModalHandle = () => {
    setOpenModalDeleteFolder(false);
    deleteFolder(formValues, product);
    setLoading(false);
  };

  const deleteFolderModalHandleCancel = () => {
    setOpenModalDeleteFolder(false);
    setLoading(false);
  };

  const handleFolderFormSubmit = () => {
    setOpenModalFolder(false);
    setOpenModalInstallation(false);
    setLoading(false);
  };

  const handleInstallationFormSubmit = () => {
    setOpenModalFolder(false);
    setOpenModalInstallation(false);
    setLoading(false);
  };

  const handleFormCancel = () => {
    setOpenModalFolder(false);
    setOpenModalInstallation(false);
  };
  const areRequiredFieldsFilled = () => {
    for (const field of requiredFields) {
      if (!formValues[field]) {
        return false;
      }
    }
    return true;
  };

  return (
    <>
      {openModalDeleteFolder && (
        <Modal
          open={openModalDeleteFolder}
          onClose={() => setOpenModalDeleteFolder(false)}
          aria-labelledby="error-modal"
          aria-describedby="error-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 350,
              bgcolor: 'background.paper',
              borderRadius: 4,
              boxShadow: 24,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography
              variant="body1"
              gutterBottom
              sx={{ fontWeight: 'bold' }}
            >
              Do you want to delete this folder?
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ fontSize: '0.875rem' }}
            >
              All installations of this folder will be deleted.
            </Typography>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 10
              }}
            >
              <Button
                sx={{
                  marginTop: 2,
                  textTransform: 'none',
                  bgcolor: '#ffc04d',
                  color: '#111111',
                  '&:hover': { bgcolor: '#f7b34d' }
                }}
                onClick={deleteFolderModalHandle}
              >
                Delete
              </Button>
              <Button
                sx={{
                  marginTop: 2,
                  marginLeft: 2,
                  textTransform: 'none',
                  bgcolor: '#ffc04d',
                  color: '#111111',
                  '&:hover': { bgcolor: '#f7b34d' }
                }}
                onClick={deleteFolderModalHandleCancel}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      {openModalFolder && (
        <FolderForm
          cancel={handleFormCancel}
          submit={handleFolderFormSubmit}
          parentid={props.folder.id}
        />
      )}
      {openModalInstallationChoice && (
        <Modal
          open={openModalInstallationChoice}
          onClose={() => {}}
          aria-labelledby="error-modal"
          aria-describedby="error-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: isMobile ? '50%' : '40%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 500,
              bgcolor: 'background.paper',
              borderRadius: 4,
              boxShadow: 24,
              p: 4
            }}
          >
            <Box
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', // Center items horizontally
                '& .MuiTextField-root': {
                  m: 1,
                  width: 390
                }
              }}
              noValidate
              autoComplete="off"
            >
              <div>
                <FormControl
                  fullWidth
                  sx={{ marginTop: 1, marginBottom: 1, width: 390 }}
                >
                  <InputLabel
                    sx={{
                      fontSize: 14,
                      backgroundColor: 'white'
                    }}
                  >
                    <FormattedMessage
                      id="producType"
                      defaultMessage="Select a Product"
                    />
                  </InputLabel>
                  <Select
                    name="product"
                    value={product}
                    onChange={handleChangeInstallationChoice}
                  >
                    {ProductTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Box>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center', // Center horizontally
                alignItems: 'center', // Center vertically
                marginTop: 20,
                gap: '10px' // Space between buttons
              }}
            >
              <Button
                variant="contained"
                onClick={handleSubmitInstallationChoice}
                sx={{
                  marginLeft: '20px'
                }}
              >
                <FormattedMessage id="submit" defaultMessage="Submit" />
              </Button>

              <Button
                variant="contained"
                onClick={handleCancelSubmitInstallationChoice}
                sx={{
                  marginLeft: '10px'
                }}
              >
                <FormattedMessage id="cancel" defaultMessage="Cancel" />
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      {openModalInstallation &&
        (product == 'Salimax' ||
          product == 'SodistoreMax') && (
          <InstallationForm
            cancel={handleFormCancel}
            submit={handleInstallationFormSubmit}
            parentid={props.folder.id}
            productToInsert={ProductTypes.indexOf(product)}
          />
        )}
      {openModalInstallation && product == 'Salidomo' && (
        <SalidomoInstallationForm
          cancel={handleFormCancel}
          submit={handleInstallationFormSubmit}
          parentid={props.folder.id}
        />
      )}

      {openModalInstallation && product == 'SodistoreHome' && (
        <SodiostorehomeInstallationForm
          cancel={handleFormCancel}
          submit={handleInstallationFormSubmit}
          parentid={props.folder.id}
        />
      )}

      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} md={12}>
            <CardContent>
              <Box
                component="form"
                sx={{
                  display: 'flex',
                  flexDirection: 'column', // Center items horizontally
                  '& .MuiTextField-root': {
                    m: 1,
                    width: 390
                  }
                }}
                noValidate
                autoComplete="off"
              >
                <div>
                  <TextField
                    label={<FormattedMessage id="name" defaultMessage="Name" />}
                    name="name"
                    value={formValues.name}
                    onChange={handleChange}
                    required
                    error={formValues.name === ''}
                  />
                </div>
                <div>
                  <TextField
                    label={
                      <FormattedMessage
                        id="information"
                        defaultMessage="Information"
                      />
                    }
                    name="information"
                    value={formValues.information}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 10
                  }}
                >
                  {currentUser.userType == UserType.admin && (
                    <Button
                      variant="contained"
                      onClick={handleDeleteFolder}
                      sx={{
                        marginLeft: '10px'
                      }}
                    >
                      <FormattedMessage
                        id="deleteFolder"
                        defaultMessage="Delete Folder"
                      />
                    </Button>
                  )}

                  {currentUser.userType == UserType.admin && (
                    <Button
                      variant="contained"
                      onClick={handleNewFolderInsertion}
                      sx={{
                        marginLeft: '10px'
                      }}
                    >
                      <FormattedMessage
                        id="addNewFolder"
                        defaultMessage="Add new folder"
                      />
                    </Button>
                  )}

                  {currentUser.userType == UserType.admin && (
                    <Button
                      variant="contained"
                      onClick={handleNewInstallationInsertion}
                      sx={{
                        marginLeft: '10px'
                      }}
                    >
                      <FormattedMessage
                        id="addNewInstallation"
                        defaultMessage="Add new installation"
                      />
                    </Button>
                  )}

                  {currentUser.userType == UserType.admin && (
                    <Button
                      variant="contained"
                      onClick={handleFolderInformationUpdate}
                      sx={{
                        marginLeft: '10px'
                      }}
                      disabled={!areRequiredFieldsFilled()}
                    >
                      <FormattedMessage
                        id="applyChanges"
                        defaultMessage="Apply Changes"
                      />
                    </Button>
                  )}

                  {loading && (
                    <CircularProgress
                      sx={{
                        color: theme.palette.primary.main,
                        marginLeft: '20px'
                      }}
                    />
                  )}
                  {error && (
                    <Alert
                      severity="error"
                      sx={{
                        ml: 1,
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <FormattedMessage
                        id="errorOccured"
                        defaultMessage="An error has occurred"
                      />
                      <IconButton
                        color="inherit"
                        size="small"
                        onClick={() => setError(false)} // Set error state to false on click
                        sx={{ marginLeft: '4px' }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Alert>
                  )}
                  {updated && (
                    <Alert
                      severity="success"
                      sx={{
                        ml: 1,
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <FormattedMessage
                        id="successfullyUpdated"
                        defaultMessage="Successfully updated"
                      />
                      <IconButton
                        color="inherit"
                        size="small"
                        onClick={() => setUpdated(false)} // Set error state to false on click
                        sx={{ marginLeft: '4px' }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Alert>
                  )}
                </div>
              </Box>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default TreeInformation;
